import { Text } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { AdvancedScheduling } from 'typings'
import { SummaryRow } from 'ui'
import { messages } from '../../messages'
import { RecurrenceTag } from './RecurrenceTag'
import styles from './style.css'

type Props = {
  scheduling: AdvancedScheduling
}

export function SchedulingRow(props: Props) {
  const { formatDate } = useIntl()
  const { scheduling } = props

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage {...messages.scheduling.title} />
      </SummaryRow.Title>
      <SummaryRow.Value>
        <div className={styles.summaryContent}>
          <RecurrenceTag recurrence={scheduling.recurrence} />
          <Text>
            <FormattedMessage
              {...messages.scheduling.dateRange}
              values={{
                start: formatDate(scheduling.start, {
                  dateStyle: 'medium',
                  timeStyle: 'short',
                }),
                end: formatDate(scheduling.end, {
                  dateStyle: 'medium',
                  timeStyle: 'short',
                }),
              }}
            />
          </Text>
        </div>
      </SummaryRow.Value>
    </SummaryRow>
  )
}
